import { useCallback } from 'react'

import { useSpotlightState } from 'hooks/useSpotlightState'

export type SpotlightTourState = {
  isDismissed: boolean
  isForceShow: boolean
  dismiss: () => void
  reset: () => void
}

/**
 * Reads and writes spotlight-tour dismissal via {@link useSpotlightState}
 * (`activation_data.spotlights`), with optional QA force-show via a query param.
 */
export function useSpotlightTourState(
  spotlightKey: string,
  forceShowParam: string,
): SpotlightTourState {
  const [spotlights, setSpotlights] = useSpotlightState() as [
    Record<string, boolean | undefined>,
    (patch: Record<string, boolean>) => void,
  ]

  const isDismissed = spotlights[spotlightKey] === true
  const isForceShow = new URLSearchParams(window.location.search).get(forceShowParam) === '1'

  const dismiss = useCallback(() => {
    setSpotlights({ [spotlightKey]: true })
  }, [setSpotlights, spotlightKey])

  const reset = useCallback(() => {
    setSpotlights({ [spotlightKey]: false })
  }, [setSpotlights, spotlightKey])

  return {
    isDismissed,
    isForceShow,
    dismiss,
    reset,
  }
}
